angular
  .module('contabilidad.catalogosexternos')
  .service(
    'CatalogosExternosProveedores',
    CatalogosExternosProveedores,
  )

CatalogosExternosProveedores.$inject = ['$http']

function CatalogosExternosProveedores ($http) {
  this.get = get
  this.put = put

  function get () {
    return $http.get('/api/contabilidad/catalogos_externos/proveedores')
  }

  function put (id_proveedor, cta_contable) {
    return $http.put('/api/contabilidad/catalogos_externos/proveedores',
      {cta_contable: cta_contable},
      {
        params: {
          id_proveedor: id_proveedor,
        },
      })
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/services/CatalogosExternosProveedores.js